<template>
  <v-container grid-list-lg class="pa-0 ma-0" fluid>

    <v-layout row wrap>
      <v-flex xs12 class="pt-0 pb-0">
        <v-card flat :style="!$vuetify.breakpoint.smAndDown ? 'padding-left: 90px; padding-right: 90px;' : 'padding-top: 15px; padding-bottom: 5px;'">
          <v-card-title class="pt-0 pb-0">
            <v-layout row wrap :align-center="$vuetify.breakpoint.smAndUp" :align-content-center="$vuetify.breakpoint.smAndDown">

              <v-flex xs12 sm3 md2 lg1>
                <v-menu
                  v-model="filtro.status.opened"
                  :close-on-content-click="false"
                  offset-y
                  transition="slide-y-transition"
                  :full-width="$vuetify.breakpoint.smAndDown"
                >
                  <v-btn
                    color="primary"
                    round
                    :outline="filtroComputed.filtroStatusString() == 'Status'"
                    slot="activator"
                    :block="$vuetify.breakpoint.smAndDown"
                  >{{filtroComputed.filtroStatusString()}}</v-btn>
                  <v-card :max-width="!$vuetify.breakpoint.smAndDown ? '170px' : ''">
                    <v-layout row wrap class="pb-0 pa-3">
                      <v-flex xs12 v-for="status in statusList" :key="status.descricao">
                        <v-btn
                          @click="filtroFunctions().selecionarStatus(status)"
                          :color="filtroComputed.statusSelecionadoDescricaoString() == status.descricao ? 'primary' : 'themeGrey'"
                          round
                          block
                          :outline="filtroComputed.statusSelecionadoDescricaoString() != status.descricao"
                        >{{status.descricao}}</v-btn>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-menu>
              </v-flex>

              <v-flex xs12 sm11 md6 lg4>
                <transition name="fade">
                  <v-flex xs1 v-if="!filtro.pesquisa.opened">
                    <v-btn
                      @click="filtroFunctions().abrirFiltroPesquisa()"
                      color="primary"
                      round
                      outline
                      v-on="on"
                      icon
                    ><v-icon>search</v-icon></v-btn>
                  </v-flex>
                  <v-flex v-else>
                    <v-text-field
                      v-model="filtro.pesquisa.conteudo"
                      prepend-icon="search"
                      @click:prepend="filtroFunctions().fecharFiltroPesquisa()"
                      @blur="filtroFunctions().fecharFiltroPesquisa()"
                      label="Busca"
                      hint="Informe o nome do grupo"
                      autofocus
                      clearable
                    ></v-text-field>
                  </v-flex>
                </transition>
              </v-flex>

            </v-layout>
          </v-card-title>
        </v-card>
      </v-flex>
    </v-layout>

    <v-container class="ml-82 mr-82 pa-24">
      <v-layout row wrap>
        <v-flex xs12 >
          <v-toolbar height="56" color="primary">
            <v-toolbar-title class="subheading white--text">Adicionar Grupo de Usuários</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn id="idAddGrupoBtn" dark color="secondary" @click="novoGrupo()" icon>
              <v-icon>add</v-icon>
            </v-btn>
          </v-toolbar>
        </v-flex>
      </v-layout>
      <br>
      <br>
      <v-flex xs12 >
        <v-layout row wrap class="scrollflex">
          <v-flex xs12 class="scrollflexcontent">
            <v-list class="pa-0" two-line  >
              <v-toolbar height="56" color="primary" >
                <v-flex xs4>
                  <v-toolbar-title class="subheading white--text">Grupo</v-toolbar-title>
                </v-flex>
                <v-spacer></v-spacer>
                <v-flex xs2>
                  <v-toolbar-title class="subheading white--text">Status</v-toolbar-title>
                </v-flex>
                <v-spacer></v-spacer>
                <v-flex xs2>
                  <v-toolbar-title class="subheading white--text">Regional</v-toolbar-title>
                </v-flex>
                <v-spacer></v-spacer>
                <v-flex xs2 text-xs-right>
                  <v-toolbar-title class="subheading white--text">Editar</v-toolbar-title>
                </v-flex>
              </v-toolbar>
              <v-list-tile v-for="grupo in grupoFilteredList" :id="'grupo-' + grupo.id" :key="grupo.id" avatar>
                <v-flex xs4>
                  <v-list-tile-content>
                    <template>
                      <v-list-tile-title :id="'grupo-' + grupo.id + '-nome'" class="themeGrey--text">
                        {{ grupo.nome }}
                      </v-list-tile-title>                                 
                    </template>
                  </v-list-tile-content>
                </v-flex>
                <v-spacer></v-spacer>
                <v-flex xs2>
                  <v-list-tile-content>
                    <span :id="'grupo-' + grupo.id + '-status'" class="themeGrey--text">{{ grupo.ativo ? 'Ativo' : 'Inativo' }}</span>
                  </v-list-tile-content>
                </v-flex>
                <v-spacer></v-spacer>
                <v-flex xs2>
                  <v-list-tile-content>
                    <span :id="'grupo-' + grupo.id + '-status'" class="themeGrey--text">{{ grupo.regional ? 'Sim' : 'Não' }}</span>
                  </v-list-tile-content>
                </v-flex>
                <v-spacer></v-spacer>
                <v-flex xs2 text-xs-right>
                  <v-btn :id="'grupo-' + grupo.id + '-editar-btn'" icon color="primary" @click="editarGrupo(grupo.id)">
                    <v-icon>edit</v-icon>
                  </v-btn>
                </v-flex>
              </v-list-tile>
            </v-list>
            <br>
            <div class="text-xs-center">
          <!--  <v-pagination
              v-model="paginacao.pagina"
              :length="paginacao.numPaginas"
              :total-visible="5"
              circle>
            </v-pagination>-->
            </div>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-snackbar
        :timeout="6000"
        :color="snackbar.sucesso ? 'success' : 'error'"
        multi-line
        v-model="snackbar.visivel">
          {{ snackbar.mensagem }}
          <v-btn dark flat @click.native="snackbar.visivel = false">Fechar</v-btn>
      </v-snackbar>
    </v-container>
  </v-container>
</template>

<script>
import axios from 'axios';
import perfil from '@/helpers/perfil';
import functions from '@/components/pages/grupo-usuarios/functions';
import usuarioHelper from '@/helpers/usuario-logado';

export default {
  name: 'GestaoGrupos',
  data () {
    return {
      on: null,
      grupoList: undefined,
      grupoListFiltrado: undefined,
      filtro: {
        status: {
          opened: false,
          selecionado: null
        },
        pesquisa: {
          opened: false,
          conteudo: ""
        },
      },
      statusList: [
        {
          descricao: 'Todos',
          ativo: null
        },
        {
          descricao: 'Ativos',
          ativo: true
        },
        {
          descricao: 'Inativos',
          ativo: false
        },
      ],
      paginacao: {
        pagina: 1,
        numPaginas: 1,
        numElementosPagina: 15
      },
      snackbar: {
        visivel: false,
        sucesso: false,
        mensagem: ''
      }
    }
  },
  computed: {
    perfilComputed: function() {
      return perfil;
    },
    grupoFilteredList: function() {
      const self = this;
      let filteredList = self.grupoList;
      
      if (self.grupoList != undefined) {
        filteredList = functions.filtro.status(filteredList, self.filtro.status.selecionado);
        filteredList = functions.filtro.busca(filteredList, self.filtro.pesquisa.conteudo);
      /*  filteredList = functions.filtro.pagina(filteredList, self.paginacao);
        self.paginacao = functions.filtro.paginaResize(filteredList, self.paginacao, self.filtro);*/
        
        return filteredList.sort((a, b) => { return a.nome.localeCompare(b.nome) });
      }
    },
    filtroComputed: function() {
      const self = this;
      return {
        filtroStatusString: function() {
          if (self.filtro.status.selecionado) {
            return self.filtro.status.selecionado.descricao;
          } else {
            return 'Status';
          }
        },
        statusSelecionadoDescricaoString: function() {
          if (self.filtro.status.selecionado) {
            return self.filtro.status.selecionado.descricao;
          } else {
            return '';
          }
        }
      }
    }
  },
  mounted: function() {
    this.carregaGrupos();
    this.externalSnackbarMessage();
  },
  methods: {
    carregaGrupos: function() {
      const self = this;
      this.$store.commit('startLoading');
      axios.get(`${process.env.URL_GRUPOMS}/v1/buscaGrupos`, {
            headers: { 'Authorization': `Bearer ${usuarioHelper.USUARIO_LOGADO().token}` } })
      .then((response) => {
        self.grupoList = response.data;
        self.$store.commit('endLoading');
      //  self.paginacao.numPaginas = parseInt(self.grupoList.length/15) + 1;
      });
    },
    novoGrupo: function() {
      this.$router.push('/GestaoGrupos/Cadastro');
    },
    editarGrupo: function(idGrupo) {
      this.$router.push('/GestaoGrupos/Cadastro/' + idGrupo);
    },
    externalSnackbarMessage: function () {
      const self = this;
      if (self.$route.params.snackbarMostrar) {
        self.snackbar.sucesso = self.$route.params.snackbarSucesso;
        self.snackbar.mensagem = self.$route.params.snackbarText;
        self.snackbar.visivel = self.$route.params.snackbarMostrar;
      }
    },
    filtroFunctions: function() {
      const self = this;
      return {
        selecionarStatus: function(status) {
          if (status) {
            self.filtro.status.selecionado = status;
            self.filtro.status.opened = false;
          }
        },
        abrirFiltroPesquisa: function() {
          self.filtro.pesquisa.opened = true;
        },
        fecharFiltroPesquisa: function() {
          if (!self.filtro.pesquisa.conteudo || self.filtro.pesquisa.conteudo == '') {
            self.filtro.pesquisa.opened = false;
          }
        }
      }
    }
  }
}
</script>

<style scoped>
.scrollflex {
  overflow-x: auto;
}
.scrollflexcontent {
  min-width: 700px;
}
</style>




// WEBPACK FOOTER //
// src/components/pages/grupo-usuarios/GestaoGrupos.vue